import { html as copyrightHtml } from '../../../../doc/legal/copyright_policy.md';
import { LegalPageLayout } from '@/components/layout/LegalPageLayout';

export function CopyrightPage() {
  return (
    <LegalPageLayout title="著作権ポリシー" lastUpdated="2025年1月11日">
      <div dangerouslySetInnerHTML={{ __html: copyrightHtml }} />
    </LegalPageLayout>
  );
}

export default CopyrightPage;
